import React from 'react';
import useLanguageCode from 'hooks/useLanguageCode';
import { IntlProvider } from 'react-intl';
import en from '../../../../compiled-lang/en.json';
import fr from '../../../../compiled-lang/fr.json';
import es from '../../../../compiled-lang/es.json';
import de from '../../../../compiled-lang/de.json';

const CustomIntlProvider: React.FC<{}> = ({ children }) => {
  const locale = useLanguageCode();

  function getMessages() {
    switch (locale) {
      case 'fr':
        return fr;
      case 'de':
        return de;
      case 'es':
        return es;
      default:
        return en;
    }
  }

  return (
    <IntlProvider defaultLocale="en" locale={locale} messages={getMessages()}>
      {children}
    </IntlProvider>
  );
};

export default CustomIntlProvider;
